// import React from "react";
import { Box, Typography } from "@mui/material";
import { DragEvent, useState, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import PDFViewer from "./PDFViewer";
import { uploadFile } from "../api/APIs";
import upload from "../images/upload.png";
import CircularProgress from "@mui/material/CircularProgress";
import { BiUpload } from "react-icons/bi";
import SubmitLoader from "./SubmitLoader";
import imageCompression from "browser-image-compression";

const UploadPDF = ({ setShowForm, setUserInfo, showForm }) => {
  const [isOver, setIsOver] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [error, setError] = useState("");
  const hiddenFileInput = useRef(null);
  const theme = useTheme();

  const handleClick = (event) => {
    if (hiddenFileInput.current) {
      hiddenFileInput.current.click();
    }
  };

  const handleChange = async (e) => {
    e.preventDefault();
    setError("");
    setIsOver(false);
    if (e.target.files) {
      if (e.target.files[0].size > 1 * 15000 * 1024) {
        setError("Only file with maximum size of 15MB is allowed");
        return;
      }
      const files = [...e.target.files];

      let count = files.length;
      if ((count && count < 0) || count > 1) {
        setError("Only 1 file can be uploaded at a time");
        return;
      }
      const fileExtension = files[0].name.split('.').pop().toLowerCase();
      if (!["pdf", "doc", "docx", "png", "jpg"].includes(fileExtension)) {
        setError("Not an acceptable format");
        return;
      }
      try {
        if (fileExtension === "png" || fileExtension === "jpg") {
          setShowLoader(true);
          const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920, 
            useWebWorker: true,
          };
          const compressedFile = await imageCompression(files[0], options);
          uploadPDF(URL.createObjectURL(compressedFile), compressedFile);
        }else {
          uploadPDF(URL.createObjectURL(files[0]), files[0]);
        }
      } catch (error) {
        setError("File compression failed. Please try again.");
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsOver(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsOver(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setError("");
    setIsOver(false);
    if (e.dataTransfer.files[0].size > 1 * 15000 * 1024) {
      setError("Only file with maximum size of 15MB is allowed");
      return;
    }
    const files = [...e.dataTransfer.files];
    let count = files.length;
    if ((count && count < 0) || count > 1) {
      setError("Only 1 file can be uploaded at a time");
      return;
    }
    const fileExtension = files[0].name.split('.').pop().toLowerCase();
    if (!["pdf", "doc", "docx", "png", "jpg"].includes(fileExtension)) {
      setError("Not an acceptable format");
      return;
    }
    try {
      if (fileExtension === "png" || fileExtension === "jpg") {
        setShowLoader(true);
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920, 
          useWebWorker: true,
        };
        const compressedFile = await imageCompression(files[0], options);
        uploadPDF(URL.createObjectURL(compressedFile), compressedFile);
      }else {
        uploadPDF(URL.createObjectURL(files[0]), files[0]);
      }
    } catch (error) {
      setError("File compression failed. Please try again.");
    }
  };

  const uploadPDF = async (file, apiFile) => {
    setShowLoader(true);
    const response = await uploadFile(apiFile);
    if (response.errorCode) {
      setError("Something went wrong. Please try again");
      setShowLoader(false);
    } else {
      setUserInfo(response);
      setUploadedFiles(file);
      setShowForm(true);
      setShowLoader(false);
      setError("");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // height: "100%",
        width: showForm ? {xs: "88%", lg: "55%"} :{ xs: "88%", lg: "35%" },
        borderRadius: "20px",
        // backgroundColor: "#fff",
        padding: "0 40px 40px 40px",
        boxShadow: "0px 0px 25px 0px rgba(0, 0, 0, 0.25)",
        flexDirection: "column",
        marginTop: showForm ? {xs: "10%", lg:'0'} : { xs: "10%", lg: "90px", xl:"110px", xxl:"190px" },
        boxSizing:'border-box',
        background: "linear-gradient(to bottom right, #C9CC84, #00B49D, #09507F)"
      }}
    >
      <SubmitLoader open={showLoader} />
      <Box width="100%" m="25px">
        <Typography
          sx={{
            fontSize: { xs: "5.5vw", sm: "5.5vw", md: "5vw", lg: "26px", xl:"40px" },
            color:'#fff',
            whiteSpace: "wrap",
          }}
          align="center"
          variant="body2"
        >
          Upload Your Bill to Compare Rates
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "400",
          }}
          align="center"
          variant="body1"
          color={"#fff"}
        >
          Acceptable formats: doc, docx, pdf, png, jpg
          <br />
          {/* Max file size: 15MB */}
        </Typography>
        {error && (
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#FF0000",
            }}
            align="center"
            variant="body1"
          >
            {error}
          </Typography>
        )}
      </Box>
      {uploadedFiles ? (
        <PDFViewer path={uploadedFiles} />
      ) : (
        <Box
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleClick}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90%",
            width: "100%",
            borderRadius: "20px",
            backgroundColor: isOver ? "lightgray" : "#EDEDED",
            cursor: "pointer",
            "&:hover": { backgroundColor: "lightgray" },
          }}
        >
          {showLoader ? (
            <CircularProgress />
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                onChange={handleChange}
                ref={hiddenFileInput}
                style={{ display: "none" }}
              />
              <BiUpload size="25px" color="#00B49D" />
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "#00B49D",
                  fontWeight: "600",
                }}
                mt="15px"
                align="center"
                variant="body1"
              >
                Drag & Drop, or Browse
              </Typography>
              {/* <img src={upload} /> */}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default UploadPDF;
